import { DataApiInputParams } from 'src/types/api';
import { Builder, getHeaders } from './utils';

export default (builder: Builder) => {
  return {
    createHelpSupportFeedback: builder.mutation({
      async queryFn(arg: DataApiInputParams, _, __, baseQuery) {
        let url = `contact-support/support`;
        return baseQuery({
          url: url,
          method: 'POST',
          body: arg.params.formData,
          ...getHeaders(url, arg.params.formData)
        });
      }
    })
  };
};
